import React, { Component } from 'react';
import PropTypes from 'prop-types'
import './styles.css';

class Checkbox extends Component {
  render() {
    const { label, isChecked, onChange, name, error, modalTrigger} = this.props;
    return (
      <div className={`checkbox__input ${error ? 'checkbox__input--error' : ''}`}>
        <input
          className="checkbox__input__field type__input__field"
          tabIndex={0}
          type="checkbox"
          name={name}
          checked={isChecked}
          onChange={onChange}
          onKeyDown={(event) => this._handleKeySubmit(event.keyCode)}
          />
        <label 
          htmlFor={label} 
          className="checkbox__input__label type__input__label"
        >
          {label}
          {this.props.modal ? (
            <React.Fragment>
              <span
                className="modal__control type__link"
                onClick={this.props.modal}
                >
                {modalTrigger}
              </span>
              <span>.</span>
            </React.Fragment>
          ) : null}
        </label>
      </div>
    )
  }

  // Custom Methods ---------------------------------------------
  _handleKeySubmit(key) {
    if (key === 13 || key === 16) {
      this.props.onChange(!this.props.isChecked)
    }
  }
}

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  modal: PropTypes.func,
  modalTrigger: PropTypes.string
}

Checkbox.defaultProps = {
  isChecked: false,
  name: "",
  error: "",
  modalTrigger: "Learn More"
}

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js